/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      site {
        siteMetadata {
          author {
            name
            summary
          }
          social {
            twitter
          }
        }
      }
    }
  `)

  // Set these values by editing "siteMetadata" in gatsby-config.js
  const author = data.site.siteMetadata?.author
  const social = data.site.siteMetadata?.social

  return (
    <div className="text-gray-700 text-xs flex my-6 flex justify-between">  
      <StaticImage
        className="w-12 h-12 rounded-full mr-2"
        layout="fixed"
        formats={["auto", "webp", "avif"]}
        src="../images/profile-pic.png"
        width={50}
        height={50}
        quality={95}
        alt="Profile picture"
      />
      {author?.name && (
        <p className="text-sm">
          Written by <strong>{author.name}</strong> {author?.summary || null}
          {` `}
          <a className="text-gray-900 font-medium leading-none hover:text-indigo-600 transition duration-500 ease-in-out" href={`https://twitter.com/${social?.twitter || ``}`}>
            Follow
          </a>
        </p>
      )}
    </div>
  )
}

export default Bio
